/* =========================================
   ROOMS PAGE VIRTUAL TOUR & MODAL ENGINE
   ========================================= */
document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollTrigger);
    const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // =========================================
    // 0. INITIAL WATERFALL LOAD & CRAYON
    // =========================================
    const introTl = gsap.timeline({ defaults: { ease: 'power3.out', duration: isReduced ? 0 : 0.8 } });
    
    // 1. Fade in the header text
    introTl.fromTo('.tour-intro h1, .tour-intro p',
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, stagger: 0.2, delay: 0.1 }
    );

    // 2. Draw the highlight crayon
    const crayonPath = document.querySelector('.crayon-svg path');
    if (crayonPath) {
        const crayonLen = crayonPath.getTotalLength();
        // Hide completely before animation to prevent the "starter blob"
        gsap.set(crayonPath, { strokeDasharray: crayonLen, strokeDashoffset: crayonLen, opacity: 0 });
        
        introTl.to(crayonPath, { opacity: 1, duration: 0.01 }, isReduced ? 0 : "-=0.4")
               .to(crayonPath, { strokeDashoffset: 0, duration: isReduced ? 0 : 0.8, ease: "power2.out" }, "<");
    }
    
    // 3. Subtly fade in the background dashed trail map immediately with the text
    introTl.fromTo('.map-path-svg', { opacity: 0 }, { opacity: 1, duration: isReduced ? 0 : 1.5 }, 0);

// =========================================
    // 1. THE TREASURE MAP SCROLL ANIMATION
    // =========================================
    const maskLine = document.querySelector('.mask-line');
    let maxProgress = 0; // Hoist maxProgress to track state across mobile resizes!
    
    function initMapPath() {
        const svg = document.querySelector('.map-path-svg');
        if (!svg) return;
        
        // Match SVG viewBox perfectly to its exact pixel size
        const w = svg.clientWidth;
        const h = svg.clientHeight;
        svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
        
        let pathStr = "";
        if (window.innerWidth <= 900) {
            // Wavy line that playfully weaves back and forth behind the stacked mobile cards
            pathStr = `M ${w*0.5},0 
                       C ${w*0.9},${h*0.1} ${w*0.9},${h*0.2} ${w*0.5},${h*0.3} 
                       C ${w*0.1},${h*0.4} ${w*0.1},${h*0.5} ${w*0.5},${h*0.6} 
                       C ${w*0.9},${h*0.7} ${w*0.9},${h*0.8} ${w*0.5},${h*0.9}
                       C ${w*0.1},${h*0.95} ${w*0.1},${h*1.0} ${w*0.5},${h}`;
        } else {
            // S-Curve perfectly mapped to exact screen pixels
            pathStr = `M ${w*0.5},0 
                       C ${w*0.8},${h*0.15} ${w*0.8},${h*0.25} ${w*0.5},${h*0.4} 
                       C ${w*0.2},${h*0.55} ${w*0.2},${h*0.65} ${w*0.5},${h*0.8} 
                       C ${w*0.8},${h*0.9} ${w*0.8},${h*0.95} ${w*0.5},${h}`;
        }
        
        // Apply responsive pixel-perfect path to all 3 SVG layers
        svg.querySelectorAll('path').forEach(p => p.setAttribute('d', pathStr));
        
        // Set exact pixel length for the solid mask animation
        if (maskLine) {
            const length = maskLine.getTotalLength();
            const startOffset = length * 1; // CHANGED: Removed the 20% head start
            
            // Re-apply maxProgress so the line doesn't disappear when mobile URL bar hides!
            const currentOffset = startOffset - (startOffset * maxProgress);
            
            gsap.set(maskLine, { strokeDasharray: length, strokeDashoffset: currentOffset });
        }
    }

    if (maskLine) {
        // Initialize dynamic responsive map path
        initMapPath();
        
        // Re-calculate paths silently on window resize
        let mapResizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(mapResizeTimer);
            mapResizeTimer = setTimeout(() => {
                initMapPath();
            }, 150);
        });

        // Custom non-reversing scroll binding
        ScrollTrigger.create({
            trigger: ".treasure-map-section",
            start: "top 50%", // CHANGED: Wait until the map is centered before drawing
            end: "bottom 85%", // Finish drawing when the bottom is near the bottom
            onUpdate: (self) => {
                // Only allow progress to go forward (never undraw)
                if (self.progress > maxProgress) {
                    maxProgress = self.progress;
                    
                    const length = maskLine.getTotalLength();
                    const startOffset = length * 1; // CHANGED: Must match the new offset above!
                    const currentOffset = startOffset - (startOffset * maxProgress);
                    
                    gsap.to(maskLine, {
                        strokeDashoffset: currentOffset,
                        duration: isReduced ? 0 : 0.5, // CHANGED: Tightened from 1s to 0.5s so it doesn't float ahead
                        ease: "power2.out",
                        overwrite: "auto" // Prevent multiple tweens from fighting
                    });
                }
            }
        });
    }

    // Node Entrance Animations (Pop in as you scroll)
    gsap.utils.toArray('.map-node').forEach(node => {
        gsap.fromTo(node, 
            { opacity: 0, y: 50 },
            { 
                opacity: 1, 
                y: 0, 
                duration: isReduced ? 0 : 0.8, 
                ease: 'back.out(1.2)',
                scrollTrigger: {
                    trigger: node,
                    start: "top 85%"
                }
            }
        );
    });

    // Animate the Playful "Click Me" Hint
    const clickHintPaths = document.querySelectorAll('.click-me-hint .crayon-svg path');
    if (clickHintPaths.length > 0) {
        clickHintPaths.forEach(path => {
            const len = path.getTotalLength();
            gsap.set(path, { strokeDasharray: len, strokeDashoffset: len, opacity: 0 });
        });
        
        const hintTl = gsap.timeline({
            scrollTrigger: {
                trigger: ".node-left",
                start: "top 65%"
            }
        });
        
        // 1. Pop text up playfully
        hintTl.fromTo('.click-me-text', 
                  { opacity: 0, y: 10 }, 
                  { opacity: 1, y: 0, duration: isReduced ? 0 : 0.6, ease: "back.out(1.5)" }
              )
              // 2. Draw the main swoop line
              .to('.click-me-hint .arrow-line', { opacity: 1, duration: 0.01 }, "drawLine")
              .to('.click-me-hint .arrow-line', { strokeDashoffset: 0, duration: isReduced ? 0 : 1.2, ease: "power2.out" }, "drawLine")
              // 3. Draw the arrowhead tip (starts 0.8s after line starts)
              .to('.click-me-hint .arrow-tip', { opacity: 1, duration: 0.01 }, isReduced ? "drawLine" : "drawLine+=0.8")
              .to('.click-me-hint .arrow-tip', { strokeDashoffset: 0, duration: isReduced ? 0 : 0.4, ease: "power2.out" }, isReduced ? "drawLine" : "drawLine+=0.8");
    }

    // =========================================
    // 2. MAGIC DOORS TRANSITION LOGIC
    // =========================================
    const transitionDoors = document.querySelector('.transition-doors');
    const doorLeft = document.querySelector('.door-left');
    const doorRight = document.querySelector('.door-right');
    const doorLogo = document.querySelector('.door-logo');

    // Reusable GSAP Timeline for the wipe transition
    const playDoorTransition = (onMidpointCallback) => {
        const tl = gsap.timeline();

        // 1. Lock screen and slide doors in
        tl.set(transitionDoors, { pointerEvents: 'all' })
          .to([doorLeft, doorRight], {
              x: '0%',
              duration: isReduced ? 0 : 0.6,
              ease: 'power4.inOut',
              stagger: 0 // Move exactly together
          })
          // 2. Pop the logo in
          .to(doorLogo, { opacity: 1, scale: 1, duration: isReduced ? 0 : 0.3, ease: 'back.out(1.5)' })
          // 3. EXECUTE MIDPOINT CALLBACK (Swap the HTML views behind the doors!)
          .call(() => {
              if (typeof onMidpointCallback === 'function') {
                  onMidpointCallback();
              }
          })
          // 4. Slight pause so the user registers the logo
          .to({}, { duration: isReduced ? 0 : 0.4 }) 
          // 5. Fade logo out and slide doors open
          .to(doorLogo, { opacity: 0, scale: 0.8, duration: isReduced ? 0 : 0.2, ease: 'power2.in' })
          .to(doorLeft, { x: '-100%', duration: isReduced ? 0 : 0.6, ease: 'power4.inOut' }, "<")
          .to(doorRight, { x: '100%', duration: isReduced ? 0 : 0.6, ease: 'power4.inOut' }, "<")
          // 6. Unlock screen
          .set(transitionDoors, { pointerEvents: 'none' });
    };

    // =========================================
    // 3. HYBRID MODAL & HASH STATE CONTROLLER
    // =========================================
    const mapSection = document.querySelector('.treasure-map-section');
    const introSection = document.querySelector('.tour-intro');
    const modalsContainer = document.getElementById('room-modals-container');
    const allModals = document.querySelectorAll('.room-modal');
    const closeBtn = document.getElementById('close-modal-btn');
    const nodes = document.querySelectorAll('.map-node');

    let isModalOpen = false;
    let lastFocusedNode = null;
    let firstFocusable = null;
    let lastFocusable = null;

    const trapFocusListener = (e) => {
        if (!isModalOpen) return;
        if (e.key === 'Tab') {
            if (e.shiftKey) { // Shift + Tab
                if (document.activeElement === firstFocusable) {
                    e.preventDefault();
                    lastFocusable.focus();
                }
            } else { // Tab
                if (document.activeElement === lastFocusable) {
                    e.preventDefault();
                    firstFocusable.focus();
                }
            }
        } else if (e.key === 'Escape') {
            closeRoom(true);
        }
    };
    
    document.addEventListener('keydown', trapFocusListener);

    // Opens a specific room modal
    const openRoom = (targetId, animate = true) => {
        const targetModal = document.getElementById(`modal-${targetId}`);
        if (!targetModal) return;

        const executeSwap = () => {
            // Hide Background Map Elements & Footer
            mapSection.style.display = 'none';
            introSection.style.display = 'none';
            const footer = document.querySelector('.site-footer');
            if (footer) footer.style.display = 'none';
            
            // Lock body scroll
            document.body.style.overflow = 'hidden';

            // Reset all modals, then activate target
            allModals.forEach(m => m.classList.remove('active'));
            modalsContainer.classList.add('active');
            modalsContainer.setAttribute('aria-hidden', 'false');
            modalsContainer.removeAttribute('inert');
            targetModal.classList.add('active');
            
            // Scroll safely to top of modal
            window.scrollTo(0, 0);

            // Populate focus trap variables
            const modalFocusables = Array.from(targetModal.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'));
            const focusableElements = [closeBtn, ...modalFocusables];

            if (focusableElements.length > 0) {
                firstFocusable = focusableElements[0];
                lastFocusable = focusableElements[focusableElements.length - 1];
                firstFocusable.focus();
            }

            // Animate Modal Contents In
            gsap.fromTo(targetModal.querySelectorAll('.room-content-col > *'), 
                { opacity: 0, y: 30 },
                { opacity: 1, y: 0, duration: isReduced ? 0 : 0.8, stagger: isReduced ? 0 : 0.1, ease: 'power3.out', delay: isReduced ? 0 : 0.2 }
            );
            gsap.fromTo(targetModal.querySelectorAll('.room-gallery-col img'), 
                { opacity: 0, scale: 0.9, y: 30 },
                { opacity: 1, scale: 1, y: 0, duration: isReduced ? 0 : 1, stagger: isReduced ? 0 : 0.15, ease: 'power3.out', delay: isReduced ? 0 : 0.4 }
            );
        };

        if (animate) {
            // Lock scroll immediately when doors start closing
            document.body.style.overflow = 'hidden';
            playDoorTransition(executeSwap);
        } else {
            executeSwap();
        }

        // Update URL and State
        history.pushState({ room: targetId }, '', `#${targetId}`);
        isModalOpen = true;
    };

    // Closes active modal and returns to map
    const closeRoom = (animate = true) => {
        const executeSwap = () => {
            modalsContainer.classList.remove('active');
            modalsContainer.setAttribute('aria-hidden', 'true');
            modalsContainer.setAttribute('inert', '');
            allModals.forEach(m => m.classList.remove('active'));
            
            // Restore Background Elements
            mapSection.style.display = 'block';
            introSection.style.display = 'block';
            const footer = document.querySelector('.site-footer');
            if (footer) footer.style.display = 'block';
            
            // Unlock body scroll
            document.body.style.overflow = '';

            // Optional: Re-trigger ScrollTrigger refresh since display changed
            ScrollTrigger.refresh();
        };

        if (animate) {
            playDoorTransition(executeSwap);
        } else {
            executeSwap();
        }

        // Clean URL
        history.pushState(null, '', window.location.pathname);
        isModalOpen = false;
    };

    // --- EVENT LISTENERS ---

    // Map Node Clicks
    nodes.forEach(node => {
        node.addEventListener('click', () => {
            const targetId = node.getAttribute('data-target');
            openRoom(targetId, true);
        });
    });

    // Back to Map Button Click
    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            closeRoom(true);
        });
    }

    // Browser Back/Forward Buttons (Crucial for Mobile UX)
    window.addEventListener('popstate', (e) => {
        const hash = window.location.hash.replace('#', '');
        if (hash && document.getElementById(`modal-${hash}`)) {
            // User went back/forward to a specific room
            openRoom(hash, true);
        } else if (isModalOpen) {
            // User went back to the root map
            closeRoom(true);
        }
    });

    // =========================================
    // 4. ON LOAD ROUTING
    // =========================================
    // If a user lands on the page with a hash (e.g. sent a link to the Kitchen)
    const initialHash = window.location.hash.replace('#', '');
    if (initialHash && document.getElementById(`modal-${initialHash}`)) {
        // Quick visual trick: Start with doors closed, then open them immediately!
        gsap.set([doorLeft, doorRight], { x: '0%' });
        gsap.set(doorLogo, { opacity: 1, scale: 1 });
        gsap.set(transitionDoors, { pointerEvents: 'all' });
        
        openRoom(initialHash, false); // Setup DOM without transition

        // Delay slightly to let fonts/images load, then open doors
        setTimeout(() => {
            gsap.to(doorLogo, { opacity: 0, scale: 0.8, duration: isReduced ? 0 : 0.2, ease: 'power2.in' });
            gsap.to(doorLeft, { x: '-100%', duration: isReduced ? 0 : 0.6, ease: 'power4.inOut' });
            gsap.to(doorRight, { x: '100%', duration: isReduced ? 0 : 0.6, ease: 'power4.inOut' });
            gsap.set(transitionDoors, { pointerEvents: 'none', delay: isReduced ? 0 : 0.6 });
        }, isReduced ? 0 : 800);
    }
});